import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a5f04e3e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=a5f04e3e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5f04e3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a5f04e3e')) {
      api.createRecord('a5f04e3e', component.options)
    } else {
      api.reload('a5f04e3e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a5f04e3e&scoped=true", function () {
      api.rerender('a5f04e3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/zdy_dragging/component/right/noticestyle/index.vue"
export default component.exports